import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { ArrowRight, Ticket } from 'lucide-react'
import { toast } from 'sonner'
import { AppHeader } from '#/components/layout/app-header'
import { Button } from '#/components/ui/button'
import { Input } from '#/components/ui/input'
import { ApiError } from '#/lib/api'
import { applyVoucher, type VoucherDto } from '#/lib/api-billing'
import { useHydratedSession } from '#/lib/auth-client'
import { fmtCurrency } from '#/lib/format'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/vouchers')({ component: Vouchers })

function Vouchers() {
  const navigate = useNavigate()
  const { data: session } = useHydratedSession()
  const [code, setCode] = useState('')
  const [result, setResult] = useState<VoucherDto | null>(null)
  const apply = async () => {
    const c = code.trim().toUpperCase()
    if (!c) return
    if (!session?.user) {
      navigate({ to: '/sign-in', search: { redirect: `/pricing?voucher=${encodeURIComponent(c)}` } as never })
      return
    }
    try {
      const r = await applyVoucher(c)
      setResult(r.voucher)
    } catch (e) {
      setResult(null)
      toast.error(e instanceof ApiError && e.code === 'invalid_voucher' ? m.voucher_invalid() : e instanceof ApiError ? e.message : m.common_error_generic())
    }
  }
  return (
    <>
      <AppHeader />
      <main className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-sm space-y-4 rounded-2xl border bg-card p-6">
          <div className="flex items-center gap-2"><Ticket className="size-5 text-primary" /><h1 className="text-2xl font-bold">{m.voucher_title()}</h1></div>
          <p className="text-sm text-muted-foreground">{m.voucher_desc()}</p>
          <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); void apply() }}>
            <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder={m.voucher_placeholder()} className="uppercase" />
            <Button type="submit" disabled={!code.trim()}>{m.voucher_apply()}</Button>
          </form>
          {result ? (
            <div className="space-y-3 rounded-xl border border-status-done/40 bg-status-done/5 p-3">
              <p className="text-sm font-medium text-status-done">{m.voucher_result({ code: result.code, value: result.kind === 'percent' ? `${result.value}%` : fmtCurrency(result.value, 'IDR') })}</p>
              <Button asChild className="w-full"><Link to="/pricing" search={{ voucher: result.code }}>{m.voucher_go_pricing()} <ArrowRight className="size-4" /></Link></Button>
            </div>
          ) : null}
        </div>
      </main>
    </>
  )
}
